module.exports = __webpack_public_path__ + "static/img/recruit.41fe0a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corporateCulture/recruit.jpg
// module id = izi2
// module chunks = 1